// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2jQvT","itemTitle":"ClientEmergencyInfo_itemTitle__kPngl","itemText":"ClientEmergencyInfo_itemText__1txJJ"};